"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var react_icons_1 = require("react-icons");

var __1 = __importDefault(require(".."));
/**
 * Wrapper of _react-icons_ GenIcon integration with the Stories-API styling
 */


var ReactIcon = function ReactIcon(_a) {
  var name = _a.name,
      data = _a.data,
      style = _a.style;
  var Icon = (0, react_icons_1.GenIcon)(data);
  return react_1.default.createElement(__1.default, {
    name: name,
    source: "react",
    style: style
  }, react_1.default.createElement(Icon, null));
};

ReactIcon.propTypes = {
  /** Name of the `Icon` */
  name: prop_types_1.default.string.isRequired,

  /** Styling object of the `Icon` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object
};
ReactIcon.defaultProps = {
  style: undefined
};
exports.default = ReactIcon;